import React from "react";
import { useTranslation } from "react-i18next";
import { SFTypography, SFStack, SFUseStyled, SFDivider } from "@sf-core";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { enrollInDomain } from "../../redux/reducers/domainReducer";
import { DOMAIN_TYPES } from "../../constants/domainTypes";
import { STATUS } from "../../constants/statuses";
import CourseItem from "./courseItem";
import CourseGroup from "./courseGroup";

const { styled } = SFUseStyled();

const CourseContainer = styled(SFStack)(({ theme }) => ({
  paddingRight: theme.spacing(2.5),
  marginBottom: theme.spacing(1),
  height: 0,
  flex: "1 0 auto",
  overflowX: "hidden",
  ...theme.scrollable,
}));

const StyledTypographyUpper = styled(SFTypography)(() => ({
  textTransform: "uppercase",
}));

const CourseList = ({
  skillPathLevelId,
  items,
  domain,
  courseDescriptionLines,
  preview = false,
  previewId = null,
}) => {
  const { t } = useTranslation();
  if (!Array.isArray(items)) return null;

  let requiredCourses = preview
    ? items.filter((x) => x.required)
    : _.orderBy(
      items.filter((x) => x.required),
      "rank",
      "asc"
    );

  let optionalCourses = _.orderBy(
    items.filter((x) => !x.required),
    "rank",
    "asc"
  );

  const dispatch = useDispatch();
  const onClick = () => {
    if (preview) {
      return;
    } else
      return domain.status === STATUS.NOT_STARTED
        ? dispatch(enrollInDomain(domain.id))
        : {};
  };

  return (
    <CourseContainer spacing={6} id="course-container">
      {!domain?.domainTypeId || domain.domainTypeId === DOMAIN_TYPES.ACADEMY ? (
        <>
          {requiredCourses.map((item, index) => (
            <CourseItem
              key={index}
              course={item}
              onClick={onClick}
              skillPathLevelId={skillPathLevelId}
              descriptionLines={courseDescriptionLines}
              preview={preview}
              previewId={previewId}
            />
          ))}
          {optionalCourses.length !== 0 && (
            <>
              {requiredCourses.length > 0 && 
              <SFStack spacing={3}>
                <React.Fragment>
                  <StyledTypographyUpper variant="body2">
                    {t("lxpComponents.courses.optionalCourses")}
                  </StyledTypographyUpper>
                  <SFDivider />
                </React.Fragment>
              </SFStack>
              }
              {optionalCourses.map((item, index) => (
                <CourseItem
                  key={index}
                  course={item}
                  skillPathLevelId={skillPathLevelId}
                  onClick={onClick}
                  descriptionLines={courseDescriptionLines}
                  preview={preview}
                  previewId={previewId}
                />
              ))}
            </>
          )}
        </>
      ) : (
        <>
          {requiredCourses.length > 0 && (
            <CourseGroup
              courses={requiredCourses}
              isUpSkillingGroup
              descriptionLines={courseDescriptionLines}
              skillPathLevelId={skillPathLevelId}
              onClick={onClick}
            />
          )}
          {optionalCourses.length > 0 && (
            <CourseGroup
              courses={optionalCourses}
              descriptionLines={courseDescriptionLines}
              skillPathLevelId={skillPathLevelId}
              onClick={onClick}
              //defaultExpanded={false}
            />
          )}
        </>
      )}
    </CourseContainer>
  );
};

export default CourseList;
